const reducer = (state, action) => {
  switch (action.type) {
    case 'updateCsvFile':
      return { ...state, csvFile: action.csvFile }
    case 'updateDescription':
      return { ...state, description: action.description }
    case 'updateSource':
      return { ...state, source: action.source }
    case 'updateInvoiceNumber':
      return { ...state, invoiceNumber: action.invoiceNumber }
    case 'updatePreviewRows':
      return { ...state, previewRows: action.previewRows }
    case 'reset':
      return {
        ...state,
        csvFile: null,
        description: '',
        source: '',
        invoiceNumber: '',
        previewRows: [],
      }
    default:
      return state
  }
}

export default reducer
